export default "https://cdn-static.gokick.com/assets/c9d0de51336abe1332e753a6383b3531473fb45b/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";